import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { TextboxTypes } from './_types';
import classes from './Textbox.module.scss';

const Textbox = props => {
	return (
		<Fragment>
			<div className={classes['input__textbox--full-width']}>
				<input {...props} />
			</div>
		</Fragment>
	);
};

Textbox.propTypes = {
	autocomplete: PropTypes.string,
	autofocus: PropTypes.bool,
	className: PropTypes.string,
	dirname: PropTypes.string,
	disabled: PropTypes.bool,
	form: PropTypes.string,
	id: PropTypes.string,
	key: PropTypes.string,
	list: PropTypes.string,
	max: PropTypes.number,
	maxlength: PropTypes.number,
	min: PropTypes.number,
	minlength: PropTypes.number,
	multiple: PropTypes.bool,
	name: PropTypes.string,
	onChange: PropTypes.func,
	pattern: PropTypes.string,
	placeholder: PropTypes.string,
	readonly: PropTypes.bool,
	required: PropTypes.bool,
	size: PropTypes.number,
	step: PropTypes.number,
	type: PropTypes.oneOf(Object.values(TextboxTypes)),
	value: PropTypes.string,
};

export default Textbox;
